import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { DataList } from './types'

export const selectEvent = (state: RootState): Event =>
  state.adminReportSQDByMaincon.Event

export const selectReportList = (state: RootState): DataList =>
  state.adminReportSQDByMaincon.DataList

export const selectFilter = (state: RootState) =>
  state.adminReportSQDByMaincon.Filter

export const selectSorting = (state: RootState) =>
  state.adminReportSQDByMaincon.sorting

export const selectInitFilter = (state: RootState) =>
  state.adminReportSQDByMaincon.ClearFilter
